module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-04-edadbf9b481df53e3de2d3b64f9881d1.jpg";